import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const contactList = gql`
  query ContactList(
    $startWeek: Int!
    $startYear: Int!
    $endWeek: Int!
    $endYear: Int!
    $userID: String!
  ) {
    contactList(
      startWeek: $startWeek
      startYear: $startYear
      endWeek: $endWeek
      endYear: $endYear
      userID: $userID
    ) {
      contactID
      userID
      time
    }
  }
`;

// It can be called getCoachingNotes - If it is going to be changed, it also needs to be changed in naws.tsx
export const getCoachingHistory = gql`
  query GetCoachingNotes(
    $week: Int
    $year: Int
    $userID: String
    $onlyCoached: Boolean
    $onlyDelivered: Boolean
  ) {
    getCoachingNotes(
      week: $week
      year: $year
      userID: $userID
      onlyCoached: $onlyCoached
      onlyDelivered: $onlyDelivered
    ) {
      id
      coachingId
      coach {
        userID
        userName
      }
      recipient {
        userID
        userName
      }
      deliveredBy {
        userID
        userName
      }
      reviewedBy {
        userID
        userName
      }
      closedBy {
        userID
        userName
      }
      createdAt
      deliveredAt
      reviewedAt
      closedAt
      updatedAt
      isDelivered
      goals {
        coachingIDs
        createdBy
        description
        endDate
        goalID
        justification
        level
        metric
        outcome
        periodType
        periodValue
        status
        targetValue
        userID
        userName
      }
      ... on Coaching {
        contactReview {
          cscContactID
          marketplaceID
          marketplaceDomainName
          followedSecurityPolicies
          content
          vertical
          relatedMetric
          contactTime {
            calWeek
            calYear
          }
        }
        coachingDetails {
          coachingTopic
          relatedContacts
          relatedContactDomains {
            cscContactID
            marketplaceDomainName
          }
          tenets
          behaviors
          relatedMetric
          assignedAction
          status
        }
        coachingSession {
          managerNotes
          coachingTactic
          coachingMethod
          duration
          preparationTime
          coachingSummaryNotes
        }
      }
      ... on NoCoach {
        reason
        otherReason
      }
    }
  }
`;

export const getAssociateProfile = gql`
  query GetAssociateProfile($userID: String!, $userName: String!) {
    getAssociateProfile(userID: $userID, userName: $userName) {
      userID
      userName
      firstName
      fullName
      isManager
      employmentStartDate
      lastCoachedDate
    }
  }
`;

export const getConsolidatedContacts = gql`
  query GetConsolidatedContacts(
    $endWeek: Int!
    $endYear: Int!
    $isTM: Boolean
    $startWeek: Int!
    $startYear: Int!
    $timeOption: TimeOption
    $timestamp: String
    $userID: String!
    $userName: String!
  ) {
    getConsolidatedContacts(
      endWeek: $endWeek
      endYear: $endYear
      isTM: $isTM
      startWeek: $startWeek
      startYear: $startYear
      timeOption: $timeOption
      timestamp: $timestamp
      userID: $userID
      userName: $userName
    ) {
      contactDeliveredUsername
      auditStartDate
      auditEndDate
      calWeek
      calYear
      category
      channel
      contactDate
      contactID
      contactInfo {
        acknowledge {
          note
          status
        }
        additionalComment
        close {
          note
          status
        }
        content
        controllable
        cscContactID
        followedSecurityPolicies
        goodRecommendation
        greet {
          note
          status
        }
        identifyProblem {
          note
          status
        }
        lastModifiedDate
        lastModifiedUser
        relatedMetric
        researchMatch {
          note
          status
        }
        resolvedProblem
        solve {
          note
          status
        }
        uncoachableReason
        uncoachableReasonText
        uncontrollableText
        verifySecurity {
          note
          status
        }
        vertical
      }
      contactStatus
      deliverInfo {
        deliverDate
        deliverStatus
        noteID
      }
      displayOrder
      duration
      marketplaceDomainName
      marketplaceID
      ownership
      recent
      recommended
      saved
      saveOrigin
      sic
      skill
      status
      userID
      concessionFeedbackCommentText
      processName
      formReviews {
        formID
        version
        formAnswer {
          questionID
          questionText {
            defaultMessage
            translationID
          }
          selectedOption {
            defaultMessage
            translationID
          }
          answerText
          value
        }
      }
      capFields {
        contactWeek
        auditWeek
        site
        flaggedForAbuse
        handledDate
        tm
        contactType
        agentLoginName
        rsprPolicyRecommendation
        rsprUtilization
        sic1
        sic2
        sic3
        sic4
        sic1_2
      }
    }
  }
`;
